"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
const noop = () => { };
const AgentActionContext = React.createContext({ sendPrompt: noop });
export function AgentActionProvider({ children, onSend }) {
    const value = React.useMemo(() => ({ sendPrompt: onSend !== null && onSend !== void 0 ? onSend : noop }), [onSend]);
    return _jsx(AgentActionContext.Provider, { value: value, children: children });
}
export function useAgentActions() {
    return React.useContext(AgentActionContext);
}
